import {QUERY_KEYS} from '@/queryClient'
import {useQueries, UseQueryOptions} from '@tanstack/react-query'
import {httpGetAccess} from '../http/accesses.http'
import {Access} from '@/features/accesses/types'

export const useGetMultipleAccesses = ({
    accessIds,
    options
}: {
    accessIds: string[]
    options?: Omit<UseQueryOptions<Access>, 'queryKey' | 'queryFn'>
}) => {
    const queries = useQueries({
        queries: accessIds.map(accessId => ({
            queryKey: [QUERY_KEYS.ACCESS, accessId],
            queryFn: () => httpGetAccess({urlParams: {accessId}}),
            ...options
        }))
    })

    return {
        ...queries,
        accesses: queries.map(query => query.data).filter(Boolean) as Access[],
        isLoading: queries.some(query => query.isLoading),
        isFetching: queries.some(query => query.isFetching),
        isError: queries.some(query => query.isError),
        isSuccess: queries.every(query => query.isSuccess)
    }
}
